import { formatCurrency } from "@utils/i18n";
import useContent from "@lib/use_content";

interface SubfaresParams {
  subfares?: be.FieldValue[];
}

export default function Subfares({ subfares }: SubfaresParams) {
  const { data, loading, error } = useContent([
    "beWebSubfareACaption",
    "beWebSubfareBCaption",
    "beWebSubfareCCaption",
    "beWebSubfareDCaption",
    "beWebSubfareECaption",
    "beWebSubfaresHeader",
    "beWebSubfaresContent",
  ]);

  if (!subfares) return null;
  return (
    <div className="p-3">
      <h3 className="mb-2 font-bold">{data?.content.beWebSubfaresHeader}</h3>
      <ul>
        {subfares.map((subfare) => {
          let label = data?.content[`beWebSubfare${subfare.field.toUpperCase()}Caption`];
          if (!label || subfare.field.includes("summary") || Number(subfare.value) == 0)
            return null;
          return (
            <li key={subfare.field} className="flex justify-between">
              <span className="mr-4 font-bold">{label}</span>
              <span className="font-number">{formatCurrency(subfare.value)}</span>
            </li>
          );
        })}
      </ul>
      {data?.content.beWebSubfaresContent && (
        <p className="mt-3 text-sm">{data?.content.beWebSubfaresContent}</p>
      )}
    </div>
  );
}
